module.exports = __webpack_public_path__ + "img/pipe_elbow.37888d6a.svg";